(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    const btn = document.getElementById('remove-enquiry');
    if (!btn) return;

    btn.addEventListener('click', function () {
      if (!confirm('Delete this enquiry?')) return;

      fetch(window.ajax_callback_data.ajax_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({
          action: 'qcs_delete_enquiry',
          id: this.dataset.id,
        }),
      }).then(() => {
        window.location.href = this.dataset.redirectUrl;
      });
    });
  });
})();
